var map = {
	"./cover1.jpg": 319,
	"./cover10.jpg": 1554,
	"./cover2.jpg": 1555,
	"./cover3.jpg": 1556,
	"./cover4.jpg": 1557,
	"./cover5.jpg": 1558,
	"./cover6.jpg": 1559,
	"./cover7.jpg": 1560,
	"./cover8.jpg": 1561,
	"./cover9.jpg": 1562,
	"./cover_black_fade_overlay.png": 1563
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1553;


//////////////////
// WEBPACK FOOTER
// ./src/images/cards/cover ^\.\/.*$
// module id = 1553
// module chunks = 0